webpackJsonp([18],{

/***/ "4Ec0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_css_page_giftDetail_scss__ = __webpack_require__("yb5t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_css_page_giftDetail_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_css_page_giftDetail_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_common_index__ = __webpack_require__("4PxH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_utils_index__ = __webpack_require__("EgtA");







function bindEvts() {
  memberFormInit();
}

function memberFormInit() {
  __WEBPACK_IMPORTED_MODULE_1_js_common_index__["n" /* memberShip */].closeForm.init();
  __WEBPACK_IMPORTED_MODULE_1_js_common_index__["n" /* memberShip */].forgetPwdFormInit({
    form: '.yui-memberform0-forgetpwd',
    mask: '.mask-member'
  });
  __WEBPACK_IMPORTED_MODULE_1_js_common_index__["n" /* memberShip */].loginFormInit({
    success: function success() {
      return Object(__WEBPACK_IMPORTED_MODULE_1_js_common_index__["l" /* headerInit */])();
    },
    form: '.yui-memberform0-login',
    mask: '.mask-member'
  });
  __WEBPACK_IMPORTED_MODULE_1_js_common_index__["n" /* memberShip */].registerFormInit({
    form: '.yui-memberform0-register',
    mask: '.mask-member'
  });
}

function QRCodeInit() {
  var parser = new __WEBPACK_IMPORTED_MODULE_2_js_utils_index__["a" /* UrlParser */]();

  __WEBPACK_IMPORTED_MODULE_1_js_common_index__["q" /* qrcode */].init({
    ht: 120,
    target: '.sec-intro .top .yui-card0halign-actionbox .qrcode',
    wt: 120
  });
  __WEBPACK_IMPORTED_MODULE_1_js_common_index__["q" /* qrcode */].init({
    ht: 140,
    prefix: parser.domainName,
    target: '.sec-summary .yui-qrbtn0 .qrcode',
    wt: 140
  });
}

function uiInit() {
  QRCodeInit();
}

window._dataBus.get('domReadyObserver').subscribe(function () {
  uiInit();
  bindEvts();
});

/***/ }),

/***/ "yb5t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["4Ec0"]);


// WEBPACK FOOTER //
// js/giftDetail.js